const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://nbkdoc.nabook.co"
    : "http://localhost:3007";

const BASE_AVATAR_URL =
  "https://newbrand.s3.eu-west-3.amazonaws.com/personnages/";

export { BASE_URL, BASE_AVATAR_URL };
